module.exports = __webpack_public_path__ + "static/img/图片 71.54e1068.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/图片 71.png
// module id = o3mG
// module chunks = 1